import { Routes } from '@angular/router';
import { DriversPage } from './drivers.page';
import { v2On } from '../v2/ui-v2.guard';


export const driversRoutes: Routes = [
    {
        path: 'drivers',
        component: DriversPage,
        children: [
            {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
            },
            {
                path: 'add',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/drivers/add-driver-v2.page').then( m => m.AddDriverV2Page)
            },
            {
                path: 'add',
                loadComponent: () => import('./add-drivers/add-drivers.page').then( m => m.AddDriversPage)
            },
            // {
            //     path: 'trips',
            //     component: TripsPage
            // },
            {
                path: 'list',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/drivers/drivers-list-v2.page').then( m => m.DriversListV2Page)
            },
            {
                path: 'details',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/drivers/driver-detail-v2.page').then( m => m.DriverDetailV2Page)
            },
            {
                path: 'list',
                loadComponent: () => import('./drivers-list/drivers-list.page').then( m => m.DriversListPage)
            },
            {
                path: 'stats',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/drivers/driver-stats-v2.page').then( m => m.DriverStatsV2Page)
            },
            {
                path: 'stats',
                loadComponent: () => import('./driver-stats/driver-stats.page').then( m => m.DriverStatsPage)
            },
            {
                path: 'admin-stats',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/drivers/driver-admin-stats-v2.page').then( m => m.DriverAdminStatsV2Page)
            },
            {
                path: 'admin-stats',
                loadComponent: () => import('./driver-admin-stats/driver-admin-stats.page').then( m => m.DriverAdminStatsPage)
            },
            // {
            //     path: 'details',
            //     loadComponent: () => import('./hub-details/hub-details.page').then( m => m.HubDetailsPage)
            // }
        ]
    },
    // {
    //     path: 'tabs/trip-detail',
    //     loadComponent: () => import('./trip-detail/trip-detail.page').then( m => m.TripDetailPage)
    // },
    
];